import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_CLOSE } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { APPOINTMENT_CLOSED_SUCCESS } from '../../constants/messages';

export function* appointmentClose(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_CLOSE, call(appointmentAPI.close, params), appointmentSchema);
    yield toastr.success('Success', APPOINTMENT_CLOSED_SUCCESS);
  } catch (e) {
    yield put(error(APPOINTMENT_CLOSE, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_CLOSE));
  }
}

export function* watchAppointmentClose() {
  yield takeEvery(APPOINTMENT_CLOSE, appointmentClose);
}

export default function* root() {
  yield all([
    fork(watchAppointmentClose)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentClose.js